import deepmerge from "deepmerge";

// Obtener oferta
const oferta = require(`./${_BBVA_CAMP}.js`).default;
const ofertaDigital = require(`./ofertaDigital.js`).default;

export default deepmerge(ofertaDigital, oferta);
